import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
const PromotionText = t0 => {
  const $ = _c(15);
  const {
    mainContent,
    subContent,
    textColor,
    topBannerText
  } = t0;
  let t1;
  if ($[0] !== textColor) {
    t1 = {
      color: textColor
    };
    $[0] = textColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = topBannerText || mainContent;
  let t3;
  if ($[2] !== t2) {
    t3 = <span dangerouslySetInnerHTML={{
      __html: t2
    }} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== subContent) {
    t4 = subContent && <span> </span>;
    $[4] = subContent;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t4) {
    t5 = <span className="PromotionText__main-content" style={t1}>{t3}{t4}</span>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== subContent) {
    t6 = <span className="PromotionText__sub-content">{subContent}</span>;
    $[10] = subContent;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
PromotionText.propTypes = {
  mainContent: PropTypes.string,
  subContent: PropTypes.node,
  textColor: PropTypes.string,
  topBannerText: PropTypes.string
};
export default PromotionText;